import useSWRMutation from "swr/mutation";
import { CheckIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { postFetcher } from "@/lib/swr";
import { useToast } from "@/hooks/use-toast";
import { toastError } from "@/lib/toast";

// Confirm a task as its assignee (or an admin unblocking a stuck one).
// Domain wiring — endpoint, which lists to revalidate, whether a rejected
// confirm surfaces a toast — comes from the caller; the rollout and RC task
// flows share this one button.
const TaskConfirmButton = ({
  endpoint,
  onConfirmed,
  errorTitle,
  className,
  variant = "outline",
  label = "Confirm",
}: {
  endpoint: string;
  onConfirmed: () => void;
  errorTitle?: string;
  className?: string;
  /** Button text; the inbox passes the server's action label (Approve…). */
  label?: string;
  /** 节点操作面板里的主动作用实心(default);列表行内保持 outline。 */
  variant?: "default" | "outline";
}) => {
  const { toast } = useToast();
  const { trigger, isMutating } = useSWRMutation(endpoint, postFetcher, {
    onSuccess: onConfirmed,
    ...(errorTitle
      ? { onError: (error: Error) => toastError(toast, errorTitle, error) }
      : {}),
  });
  return (
    <Button
      variant={variant}
      size="sm"
      disabled={isMutating}
      onClick={(e) => {
        e.stopPropagation();
        trigger({ confirmed: true });
      }}
      className={cn("h-7 gap-1.5 px-2 text-xs", className)}
    >
      <CheckIcon className="h-3.5 w-3.5" />
      {isMutating ? `${label.replace(/e$/, "")}ing…` : label}
    </Button>
  );
};

export default TaskConfirmButton;
